import _ from 'lodash';
import OPERATORS from '../constants/operators';

const operatorMap = {
  [OPERATORS.EQUALS]: (value, num) => value === num,
  [OPERATORS.GREATER_THAN]: (value, num) => value > num,
  [OPERATORS.GREATER_THAN_EQUAL_TO]: (value, num) => value >= num,
  [OPERATORS.SMALLER_THAN]: (value, num) => value < num,
  [OPERATORS.SMALLER_THAN_EQUAL_TO]: (value, num) => value <= num,
  [OPERATORS.BETWEEN]: (value, start, end) => value >= start && value <= end,
};
const numberFilterMethod = (filter, row) => {
  const {
    operator,
    number,
    endNumber,
    multiSelectValues,
    clearFilter,
  } = filter.value;
  const rowValue = row[filter.id];

  if (clearFilter) {
    return true;
  }

  if (multiSelectValues && multiSelectValues.length) {
    return !!_.find(multiSelectValues, { value: rowValue === undefined ? null : rowValue });
  }

  return !operatorMap[operator] || operatorMap[operator](rowValue, number, endNumber);
};

export default numberFilterMethod;
